// Передача з екрана посадки на екран кавенятка: що посаджено й яким кущ був
// до того. Після «Посадити» екран кавенятка монтується наново (pop()), тож
// стан компонента тут не допоможе — лишаємо записку в модулі, і кавенятко
// забирає її один раз.
//
// Навіщо: кущ має змінитися на очах — спершу такий, як був, над ним
// сиплеться компост чи бризкає інсектицид, і лише потім він виростає
// (власник, 27.09.2026). Без старого вигляду показати «до» нема з чого.
//
// Записка старіє за 10 с: якщо кавенятко з якоїсь причини не відкрилось
// одразу, програвати перехід згодом, посеред чогось іншого, не треба.
const TTL_MS = 10000;
let note = null;

export function leaveHandoff(h) {
  note = { ...h, at: Date.now() };
}

export function takeHandoff() {
  const h = note;
  note = null;
  return h && Date.now() - h.at < TTL_MS ? h : null;
}
